<style lang="scss">

</style>

<template>
<div id="admin">
    <h1 class="title">admin</h1>
    <div v-cloak>
        <div class="columns twelve">
            <button @click="testEmail">Test Email</button>
            <br />
            {{ myAuth }}
        </div>
        <hr />
        <div>
            <div class="column one-half">
                <h2>users</h2>
                <div v-for="user in users" :key="user._id">
                    <!-- <template v-if="!user_clone"> -->
                    <div v-for="(value, name) in user" :key="name">
                        <span v-if="name === 's2019' && value">
                            {{ name }}: {{ value.recipient.name }}
                        </span>
                        <span v-else>
                            {{ name }}: {{ value }}
                        </span>
                    </div>
                    <button @click="updateUser(user)">Update</button>
                    <button @click="resetPassword(user)">Reset Password</button>
                    <!-- </template>
                    <template v-else>
                        <div> _id: {{ user._id }} </div>
                        <div> name: <input type="text" v-model="user_clone.name" /> </div>
                        <div> lover_id: <input type="text" v-model="user_clone.name" /> </div>
                    </template> -->
                    <hr />
                </div>
            </div>
            <div class="column one-half">
                <h2>secret santa</h2>
                <button @click="generateSecretSanta">generate</button>
                <div>
                    {{ message }}
                </div>
                <!-- <button>by year</button>
                <button>by user</button>
                <table>
                    <thead>
                        <tr>
                            <th>year</th>
                            <th>giver</th>
                            <th>recipient</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td rowspan="3">2019</td>
                            <td>g</td>
                            <td>r</td>
                        </tr>
                        <tr>
                            <td>g</td>
                            <td>r</td>
                        </tr>
                        <tr>
                            <td>g</td>
                            <td>r</td>
                        </tr>
                    </tbody>
                </table>
                <table>
                    <thead>
                        <tr>
                            <th>giver</th>
                            <th>year</th>
                            <th>recipient</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td rowspan="3">g</td>
                            <td>year</td>
                            <td>r</td>
                        </tr>
                        <tr>
                            <td>year</td>
                            <td>r</td>
                        </tr>
                        <tr>
                            <td>year</td>
                            <td>r</td>
                        </tr>
                    </tbody>
                </table> -->
            </div>
        </div>
    </div>
</div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import { auth } from '../core/auth.js';
export default {
    name: 'Admin',
    data: function() {
        return {
            // myAuth: auth.session,
            users: [],
            secret_santas: {},
            assigned: [],
            message: '',
        };
    },
    computed: {
        year: function() {
            return {
                current: moment().format('YYYY'),
                minus_one: moment().subtract(1, 'years').format('YYYY'),
                minus_two: moment().subtract(2, 'years').format('YYYY'),
            };
        },
        myAuth: function() {
            return auth.session;
        }
    },
    created: async function() {
        // get users and secret_santas
        let res = await fetch(`/api/graphql`, {
            method: 'POST',
            headers: {},
            credentials: 'same-origin',
            body: JSON.stringify({
                query: `query {
                    users {
                        data {
                            _id
                            name
                            email
                            lover {
                                _id
                                name
                            }
                            wishlist {
                                description
                                link
                            }
                        }
                    }

                    secretSantas {
                        data {
                            year
                            giver { _id name }
                            recipient { _id name }
                        }
                    }
                }`,
            }),
        });
        res = await res.json();
        if (res.secretSantas.data.length) {
            this.secret_santas = _.groupBy(res.secretSantas.data, 'year');
        }
        this.users = res.users.data.map(u => {
            let year = this.secret_santas[this.year.minus_one];
            if (year) {
                let ss = year.find(s => s.giver._id === u._id);
                u[`s${this.year.minus_one}`] = ss;
            }
            return u;
        });
    },
    methods: {
        generateSecretSanta: async function() {
            let allAssigned = false;
            let assigned = [];
            let count = 0;
            while (!allAssigned) {
                console.log(`attempt: ${count}`);
                assigned = this.getSecretSantas();
                allAssigned = !assigned.includes(null);
            }

            for (let secret_santa of assigned) {
                let res = await fetch(`/api/graphql`, {
                    method: 'POST',
                    headers: {
                        'Cache-Control': 'max-age=0'
                    },
                    credentials: 'same-origin',
                    body: JSON.stringify({
                        query: `mutation ($data: SecretSantaInput!) {
                            createSecretSanta(data: $data) {
                                giver {
                                    _id
                                    name
                                    email
                                }
                                recipient {
                                    _id
                                    name
                                    email
                                }
                            }
                        }`,
                        variables: {
                            data: secret_santa
                        },
                    }),
                });
                res = await res.json();

                await this.email({ ... res.createSecretSanta});
            }
            this.message = 'Done!';
        },
        getSecretSantas: function() {
            let remaining = _.chain(this.users)
                .cloneDeep()
                .shuffle()
                .value();

            return this.users.map(u => {
                let valid_opts = _.chain(remaining)
                    .filter(r => {
                        let conditions = [
                            u._id, // current giver
                            _.get(u, 'lover._id'), // giver's lover
                            _.get(u, [`s${this.year.minus_one}`, 'recipient', '_id']), // recipient of 1 year ago
                            // _.get(u, [`s${this.year.minus_two}`, 'recipient', '_id']), // recipient of 2 years ago
                        ];

                        return !conditions.includes(r._id);
                    })
                    .shuffle()
                    .value();

                if (valid_opts.length) {
                    _.remove(remaining, r => r._id === valid_opts[0]._id);
                    return {
                        year: this.year.current,
                        giver: { connect: u._id },
                        recipient: { connect: valid_opts[0]._id },
                    };
                }
                return null;
            });
        },
        resetPassword: async function(user) {},
        updateUser: async function(user) {},
        testEmail: async function() {
            await this.email({
                giver: this.users.find(u => u._id === '283867332608000512'),
                recipient: this.users.find(u => u._id === '283867332608000512'),
            });
        },
        email: async function({ giver, recipient }) {
            // console.log(giver);
            // console.log(recipient);
            await fetch(`/api/email`, {
                method: 'POST',
                headers: {},
                body: JSON.stringify({ giver, recipient, }),
                credentials: 'same-origin',
            });
        },
    },
};
</script>
